export default class inventarioService{
	constructor($http, baseUrl){
		this.http = $http;
		this.baseUrl = baseUrl;
		this.routes = {
			"all": '/api/inventario',
			"filter" : "/api/inventario/filter",
			"id": '/api/inventario/:id',
			"new": '/api/inventario',
			"delete": '/api/inventario/:id',
			"pre_equipo_list" : "/api/inventario/pre",
			"pre_equipo_view" : "/api/inventario/pre/:id",
			"pre_equipo_delete": "/api/inventario/pre/:id",
			"pdf": "/api/inventario/pdf",
			"getPdf": "/api/inventario/pdf/:pdf",
			"serialNumber": '/api/inventario/by-location-position'
		};
	}

	getBy(data){
		let url = this.baseUrl + this.routes.filter;
		return this.http.post(url, data);
	}

	getAll(params){
		let url = this.baseUrl + this.routes.all;
		var config = {
		};
		if (params !== undefined) {
			if (typeof params == 'string') {
				config.params = {};
				config.params.string = params;
			}else{
				config.params = {};
				for (var element in params) {
					config.params[element] = params[element];
				}
				config.params.proyectos = params.proyectos;
			}
		}
		// console.log(config);
		return this.http.get(url, config);
	}

	getById(objId){
		let idRoute = this.routes.id.replace(':id', objId.id);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	save(data){
		let url = this.baseUrl + this.routes.new;
		return this.http.post(url, data);
	}

	destruct(objId){
		let url = this.baseUrl + this.routes.delete;
		let idRoute = this.routes.delete.replace(':id', objId);
		this.http.delete();
	}

	update(data){
		let idRoute = this.routes.id.replace(':id', data._id);
		let url = this.baseUrl + idRoute;
		let config = {
			params : data
		};
		return this.http.put(url, config);
	}

	registrarMovimiento(data){
		let url = this.baseUrl + this.routes.mover;
		// let dat = {
		// 	params : data
		// };
		return this.http.post(url, data);
	}

	list_completar(params){
		let url = this.baseUrl + this.routes.pre_equipo_list;
		var config = {};
		if (params !== undefined) {
			if (typeof params == 'string') {
				config.params = {};
				config.params.string = params;
			}else{
				config.params = {};
				for (var element in params) {
					config.params[element] = params[element];
				}
				config.params.proyectos = params.proyectos;
			}
		}

		return this.http.get(url, config);
	}

	view_completar(data){
		let idRoute = this.routes.pre_equipo_view.replace(':id', data.id);
		let url     = this.baseUrl + idRoute;
		let config  = {};

		return this.http.get(url, config);
	}

	pre_equipo_delete(data){
		let idRoute = this.routes.pre_equipo_delete.replace(':id', data.id);
		let url     = this.baseUrl + idRoute;
		let config  = {};

		return this.http.delete(url, config);
	}

	pdf(data){
		let url = this.baseUrl + this.routes.pdf;
		return this.http.post(url, data);
	}

	getPdf(data){
		let idRoute = this.routes.getPdf.replace(':pdf', data.pdf);
		let url = this.baseUrl + idRoute;
		return this.http.get(url);
	}

	getSerialNumber(data){
		let url = this.baseUrl + this.routes.serialNumber;
		return this.http.post(url, data);
	}
}



// WEBPACK FOOTER //
// ./app/js/services/inventarioService.js